module.exports = __webpack_public_path__ + "resources/img/img-main-valuation.1d503799.png";